module.exports = __webpack_public_path__ + "img/3.ab26d718.jpg";